module.exports = __webpack_public_path__ + "static/media/calendar.a9ffbae9.svg";